var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',{staticClass:"mt-4"},[_c('img',{staticClass:"mb-2 mr-2",attrs:{"src":_vm.imgSrc,"width":"38","height":"38"}}),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }